import React from "react";

import { links } from "../lib/sitemap";
import { Link, useLocation } from "react-router-dom";

const LinkItem = ({ activePaths, currentPath, label, path }) => {
    const isPath = currentPath === path;
    let hasActivePath = false;
    activePaths.forEach((p) => {
        if (currentPath.includes(p)) {
            hasActivePath = true;
        }
    });

    const activeClass = isPath || hasActivePath ? "-active" : "";

    return (
        <li className={activeClass}>
            <Link to={path}>{label}</Link>
        </li>
    );
};

const SideNavigation = () => {
    const { pathname } = useLocation();
    const currentPath = pathname || "";
    const linkItems = links.map((i, index) => {
        return (
            <LinkItem
                key={`nav-${index}`}
                {...i}
                currentPath={currentPath}
            />
        );
    });

    return <ul className="side-navigation">{linkItems}</ul>;
};

export default SideNavigation;
